import React from "react";

export const EnabledColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${row.enabled ? "success":"danger"} label-inline`}
  >
    {row.enabled?"Enabled":"Disabled"}
  </span>
);
